export default __webpack_public_path__ + "static/media/non1.30e8e204.png";